import { createSlice } from "@reduxjs/toolkit";

export const teamSlice = createSlice({
  name: "team",
  initialState: {
    groups: [
      {
        groupName: "GRUPO A",
        teams: [
          {
            nation: "Senegal",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Ecuador",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Países Bajos",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Qatar",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
        ],
        matches: [
          {
            matchTeams: [
              { nation: "Qatar", goals: "2" },
              { nation: "Ecuador", goals: "2" },
            ],
            matchDetail:
              "Estadio Al Bayt, Jor - Domingo 20 de noviembre - 12:00 am",
          },
          {
            matchTeams: [
              { nation: "Senegal", goals: "0" },
              { nation: "Países Bajos", goals: "2" },
            ],
            matchDetail:
              "Estadio Al Thumama, Doha - Lunes 21 de noviembre - 7:00 am",
          },
          {
            matchTeams: [
              { nation: "Qatar", goals: "1" },
              { nation: "Senegal", goals: "3" },
            ],
            matchDetail:
              "Estadio Al Thumama, Doha - Viernes 25 de noviembre - 10:00 am",
          },
          {
            matchTeams: [
              { nation: "Países Bajos", goals: "1" },
              { nation: "Ecuador", goals: "1" },
            ],
            matchDetail:
              "Estadio Internacional Khalifa, Rayán - Viernes 25 de noviembre - 1:00 pm",
          },
          {
            matchTeams: [
              { nation: "Ecuador", goals: "1" },
              { nation: "Senegal", goals: "2" },
            ],
            matchDetail:
              "Estadio Internacional Khalifa, Rayán - Martes 29 de noviembre - 12:00 pm",
          },
          {
            matchTeams: [
              { nation: "Países Bajos", goals: "2" },
              { nation: "Qatar", goals: "0" },
            ],
            matchDetail:
              "Estadio Al Bayt, Jor - Martes 29 de noviembre - 12:00 pm",
          },
        ],
        isAllFilled: false,
        isCalcBtnClicked: false,
      },
      {
        groupName: "GRUPO B",
        teams: [
          {
            nation: "Gales",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Estados Unidos",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Irán",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Inglaterra",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
        ],
        matches: [
          {
            matchTeams: [
              { nation: "Inglaterra", goals: "6" },
              { nation: "Irán", goals: "2" },
            ],
            matchDetail:
              "Estadio Internacional Khalifa, Rayán - Lunes 21 de noviembre - 10:00 am",
          },
          {
            matchTeams: [
              { nation: "Estados Unidos", goals: "1" },
              { nation: "Gales", goals: "1" },
            ],
            matchDetail:
              "Estadio Internacional Khalifa, Rayán - Lunes 21 de noviembre - 4:00 pm",
          },
          {
            matchTeams: [
              { nation: "Gales", goals: "0" },
              { nation: "Irán", goals: "2" },
            ],
            matchDetail:
              "Estadio Internacional Khalifa, Rayán - Viernes 25 de noviembre - 7:00 pm",
          },
          {
            matchTeams: [
              { nation: "Inglaterra", goals: "0" },
              { nation: "Estados Unidos", goals: "0" },
            ],
            matchDetail:
              "Estadio Al Bayt, Jor - Viernes 25 de noviembre - 4:00 pm",
          },
          {
            matchTeams: [
              { nation: "Gales", goals: "0" },
              { nation: "Inglaterra", goals: "0" },
            ],
            matchDetail:
              "Estadio Internacional Khalifa, Rayán - Martes 29 de noviembre - 4:00 pm",
          },
          {
            matchTeams: [
              { nation: "Irán", goals: "0" },
              { nation: "Estados Unidos", goals: "1" },
            ],
            matchDetail:
              "Estadio Al Thumama, Doha - Martes 29 de noviembre - 4:00 pm",
          },
        ],
        isAllFilled: false,
        isCalcBtnClicked: false,
      },
      {
        groupName: "GRUPO C",
        teams: [
          {
            nation: "Polonia",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "México",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Arabia Saudita",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Argentina",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
        ],
        matches: [
          {
            matchTeams: [
              { nation: "Argentina", goals: "1" },
              { nation: "Arabia Saudita", goals: "2" },
            ],
            matchDetail:
              "Estadio Icónico, Lusail - Martes 22 de noviembre - 7:00 am",
          },
          {
            matchTeams: [
              { nation: "México", goals: "0" },
              { nation: "Polonia", goals: "0" },
            ],
            matchDetail:
              "Estadio 974, Doha - Martes 22 de noviembre - 1:00 pm",
          },
          {
            matchTeams: [
              { nation: "Polonia", goals: "2" },
              { nation: "Arabia Saudita", goals: "0" },
            ],
            matchDetail:
              "Estadio Ciudad de la Educación, Rayán - Sábado 26 de noviembre - 10:00 am",
          },
          {
            matchTeams: [
              { nation: "Argentina", goals: "2" },
              { nation: "México", goals: "0" },
            ],
            matchDetail:
              "Estadio Icónico, Lusail - Sábado 26 de noviembre - 4:00 pm",
          },
          {
            matchTeams: [
              { nation: "Polonia", goals: "" },
              { nation: "Argentina", goals: "" },
            ],
            matchDetail:
              "Estadio 974, Doha - Miércoles 30 de noviembre - 4:00 pm",
          },
          {
            matchTeams: [
              { nation: "Arabia Saudita", goals: "" },
              { nation: "México", goals: "" },
            ],
            matchDetail:
              "Estadio Icónico, Lusail - Miércoles 30 de noviembre - 4:00 pm",
          },
        ],
        isAllFilled: false,
        isCalcBtnClicked: false,
      },
      {
        groupName: "GRUPO D",
        teams: [
          {
            nation: "Túnez",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Dinamarca",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Australia",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Francia",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
        ],
        matches: [
          {
            matchTeams: [
              { nation: "Dinamarca", goals: "0" },
              { nation: "Túnez", goals: "0" },
            ],
            matchDetail:
              "Estadio Ciudad de la Educación, Rayán - Martes 22 de noviembre - 10:00 am",
          },
          {
            matchTeams: [
              { nation: "Francia", goals: "4" },
              { nation: "Australia", goals: "1" },
            ],
            matchDetail:
              "Estadio Al Janoub, Al Wakrah - Martes 22 de noviembre - 4:00 pm",
          },
          {
            matchTeams: [
              { nation: "Túnez", goals: "0" },
              { nation: "Australia", goals: "1" },
            ],
            matchDetail:
              "Estadio Al Janoub, Al Wakrah - Sábado 26 de noviembre - 7:00 am",
          },
          {
            matchTeams: [
              { nation: "Francia", goals: "2" },
              { nation: "Dinamarca", goals: "1" },
            ],
            matchDetail:
              "Estadio 974, Doha - Sábado 26 de noviembre - 1:00 pm",
          },
          {
            matchTeams: [
              { nation: "Australia", goals: "" },
              { nation: "Dinamarca", goals: "" },
            ],
            matchDetail:
              "Estadio Al Janoub, Al Wakrah - Miércoles 30 de noviembre - 12:00 pm",
          },
          {
            matchTeams: [
              { nation: "Túnez", goals: "" },
              { nation: "Francia", goals: "" },
            ],
            matchDetail:
              "Estadio Ciudad de la Educación, Rayán - Miércoles 30 de noviembre - 12:00 pm",
          },
        ],
        isAllFilled: false,
        isCalcBtnClicked: false,
      },
      {
        groupName: "GRUPO E",
        teams: [
          {
            nation: "Japón",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Alemania",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Costa Rica",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "España",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
        ],
        matches: [
          {
            matchTeams: [
              { nation: "Alemania", goals: "1" },
              { nation: "Japón", goals: "2" },
            ],
            matchDetail:
              "Estadio Internacional Khalifa, Rayán - Miércoles 23 de noviembre - 10:00 am",
          },
          {
            matchTeams: [
              { nation: "España", goals: "7" },
              { nation: "Costa Rica", goals: "0" },
            ],
            matchDetail:
              "Estadio Al Thumama, Doha - Miércoles 23 de noviembre - 12:00 pm",
          },
          {
            matchTeams: [
              { nation: "Japón", goals: "0" },
              { nation: "Costa Rica", goals: "1" },
            ],
            matchDetail:
              "Estadio Ahmed bin Ali, Rayán - Domingo 27 de noviembre - 7:00 am",
          },
          {
            matchTeams: [
              { nation: "España", goals: "1" },
              { nation: "Alemania", goals: "1" },
            ],
            matchDetail:
              "Estadio Al Bayt, Jor - Domingo 27 de noviembre - 4:00 pm",
          },
          {
            matchTeams: [
              { nation: "Japón", goals: "" },
              { nation: "España", goals: "" },
            ],
            matchDetail:
              "Estadio Internacional Khalifa, Rayán - Jueves 1 de diciembre - 4:00 pm",
          },
          {
            matchTeams: [
              { nation: "Costa Rica", goals: "" },
              { nation: "Alemania", goals: "" },
            ],
            matchDetail:
              "Estadio Al Bayt, Jor - Jueves 1 de diciembre - 4:00 pm",
          },
        ],
        isAllFilled: false,
        isCalcBtnClicked: false,
      },
      {
        groupName: "GRUPO F",
        teams: [
          {
            nation: "Croacia",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Marruecos",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Canadá",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Bélgica",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
        ],
        matches: [
          {
            matchTeams: [
              { nation: "Marruecos", goals: "0" },
              { nation: "Croacia", goals: "0" },
            ],
            matchDetail:
              "Estadio Al Bayt, Jor - Miércoles 23 de noviembre - 7:00 am",
          },
          {
            matchTeams: [
              { nation: "Bélgica", goals: "1" },
              { nation: "Canadá", goals: "0" },
            ],
            matchDetail:
              "Estadio Ahmed bin Ali, Rayán - Miércoles 23 de noviembre - 4:00 pm",
          },
          {
            matchTeams: [
              { nation: "Bélgica", goals: "0" },
              { nation: "Marruecos", goals: "2" },
            ],
            matchDetail:
              "Estadio Al Thumama, Doha - Domingo 27 de noviembre - 10:00 am",
          },
          {
            matchTeams: [
              { nation: "Croacia", goals: "4" },
              { nation: "Canadá", goals: "1" },
            ],
            matchDetail:
              "Estadio Internacional Khalifa, Rayán - Domingo 27 de noviembre - 1:00 pm",
          },
          {
            matchTeams: [
              { nation: "Croacia", goals: "" },
              { nation: "Bélgica", goals: "" },
            ],
            matchDetail:
              "Estadio Ahmed bin Ali, Rayán - Jueves 1 de diciembre - 1:00 pm",
          },
          {
            matchTeams: [
              { nation: "Canadá", goals: "" },
              { nation: "Marruecos", goals: "" },
            ],
            matchDetail:
              "Estadio Al Thumama, Doha - Jueves 1 de diciembre - 1:00 pm",
          },
        ],
        isAllFilled: false,
        isCalcBtnClicked: false,
      },
      {
        groupName: "GRUPO G",
        teams: [
          {
            nation: "Camerún",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Suiza",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Serbia",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Brasil",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
        ],
        matches: [
          {
            matchTeams: [
              { nation: "Suiza", goals: "1" },
              { nation: "Camerún", goals: "0" },
            ],
            matchDetail:
              "Estadio Al Janoub, Al Wakrah - Jueves 24 de noviembre - 7:00 am",
          },
          {
            matchTeams: [
              { nation: "Brasil", goals: "2" },
              { nation: "Serbia", goals: "0" },
            ],
            matchDetail:
              "Estadio Icónico, Lusail - Jueves 24 de noviembre - 4:00 pm",
          },
          {
            matchTeams: [
              { nation: "Camerún", goals: "3" },
              { nation: "Serbia", goals: "3" },
            ],
            matchDetail:
              "Estadio Al Janoub, Al Wakrah - Lunes 28 de noviembre - 7:00 am",
          },
          {
            matchTeams: [
              { nation: "Brasil", goals: "1" },
              { nation: "Suiza", goals: "0" },
            ],
            matchDetail: "Estadio 974, Doha - Lunes 28 de noviembre - 1:00 pm",
          },
          {
            matchTeams: [
              { nation: "Serbia", goals: "" },
              { nation: "Suiza", goals: "" },
            ],
            matchDetail: "Estadio 974, Doha - Viernes 2 de diciembre - 4:00 pm",
          },
          {
            matchTeams: [
              { nation: "Camerún", goals: "" },
              { nation: "Brasil", goals: "" },
            ],
            matchDetail:
              "Estadio Icónico, Lusail - Viernes 2 de diciembre - 4:00 pm",
          },
        ],
        isAllFilled: false,
        isCalcBtnClicked: false,
      },
      {
        groupName: "GRUPO H",
        teams: [
          {
            nation: "Corea del Sur",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Uruguay",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Ghana",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
          {
            nation: "Portugal",
            pj: 0,
            pg: 0,
            pe: 0,
            pp: 0,
            gf: 0,
            gc: 0,
            dif: 0,
            pts: 0,
          },
        ],
        matches: [
          {
            matchTeams: [
              { nation: "Uruguay", goals: "0" },
              { nation: "Corea del Sur", goals: "0" },
            ],
            matchDetail:
              "Estadio Ciudad de la Educación, Rayán - Jueves 24 de noviembre - 10:00 am",
          },
          {
            matchTeams: [
              { nation: "Portugal", goals: "3" },
              { nation: "Ghana", goals: "2" },
            ],
            matchDetail:
              "Estadio 974, Doha - Jueves 24 de noviembre - 1:00 pm",
          },
          {
            matchTeams: [
              { nation: "Corea del Sur", goals: "2" },
              { nation: "Ghana", goals: "3" },
            ],
            matchDetail:
              "Estadio Ciudad de la Educación, Rayán - Lunes 28 de noviembre - 10:00 am",
          },
          {
            matchTeams: [
              { nation: "Portugal", goals: "2" },
              { nation: "Uruguay", goals: "0" },
            ],
            matchDetail:
              "Estadio Icónico, Lusail - Lunes 28 de noviembre - 4:00 pm",
          },
          {
            matchTeams: [
              { nation: "Ghana", goals: "" },
              { nation: "Uruguay", goals: "" },
            ],
            matchDetail:
              "Estadio Al Janoub, Al Wakrah - Viernes 2 de diciembre - 1:00 pm",
          },
          {
            matchTeams: [
              { nation: "Corea del Sur", goals: "" },
              { nation: "Portugal", goals: "" },
            ],
            matchDetail:
              "Estadio Ciudad de la Educación, Rayán - Viernes 2 de diciembre - 12:00 pm",
          },
        ],
        isAllFilled: false,
        isCalcBtnClicked: false,
      },
    ],
    step: {
      groupStage: false,
      knockOut16: false,
      knockOut8: false,
      semiFinal: true,
      final: false,
      result: false,
    },
    knockoutStageMatches: [
      [
        { nation: "Argentina", winner: true },
        { nation: "Croacia", winner: false },
      ],
      [
        { nation: "Francia", winner: false },
        { nation: "Marruecos", winner: false },
      ],
    ],
  },
  reducers: {
    changeMatchGoals: (state, action) => {
      state.groups[action.payload.groupIdx].matches[
        action.payload.matchIdx
      ].matchTeams[action.payload.matchTeamIdx].goals =
        action.payload.teamGoals;
    },
    checkAllFilled: (state, action) => {
      let matchFilled = true;
      for (let i = 0; i < state.groups[action.payload].matches.length; i++) {
        for (
          let j = 0;
          j < state.groups[action.payload].matches[i].matchTeams.length;
          j++
        ) {
          if (
            state.groups[action.payload].matches[i].matchTeams[j].goals === ""
          ) {
            matchFilled = false;
            break;
          } else {
            continue;
          }
        }
        if (!matchFilled) {
          break;
        }
      }
      state.groups[action.payload].isAllFilled = matchFilled;
    },
    updateTeamScore: (state, action) => {
      if (
        state.groups[action.payload.groupIdx].teams[action.payload.teamIdx]
          .pj === 3
      ) {
        state.groups[action.payload.groupIdx].teams[
          action.payload.teamIdx
        ].pj = 0;
        state.groups[action.payload.groupIdx].teams[
          action.payload.teamIdx
        ].pg = 0;
        state.groups[action.payload.groupIdx].teams[
          action.payload.teamIdx
        ].pe = 0;
        state.groups[action.payload.groupIdx].teams[
          action.payload.teamIdx
        ].pp = 0;
        state.groups[action.payload.groupIdx].teams[
          action.payload.teamIdx
        ].gf = 0;
        state.groups[action.payload.groupIdx].teams[
          action.payload.teamIdx
        ].gc = 0;
        state.groups[action.payload.groupIdx].teams[
          action.payload.teamIdx
        ].dif = 0;
        state.groups[action.payload.groupIdx].teams[
          action.payload.teamIdx
        ].pts = 0;
      }
      state.groups[action.payload.groupIdx].teams[
        action.payload.teamIdx
      ].pj += 1;
      state.groups[action.payload.groupIdx].teams[action.payload.teamIdx].gf +=
        action.payload.goalF;
      state.groups[action.payload.groupIdx].teams[action.payload.teamIdx].gc +=
        action.payload.goalC;
      let goalDiff = action.payload.goalF - action.payload.goalC;
      state.groups[action.payload.groupIdx].teams[action.payload.teamIdx].dif +=
        goalDiff;
      if (goalDiff > 0) {
        state.groups[action.payload.groupIdx].teams[
          action.payload.teamIdx
        ].pg += 1;
        state.groups[action.payload.groupIdx].teams[
          action.payload.teamIdx
        ].pts += 3;
      } else if (goalDiff < 0) {
        state.groups[action.payload.groupIdx].teams[
          action.payload.teamIdx
        ].pp += 1;
      } else {
        state.groups[action.payload.groupIdx].teams[
          action.payload.teamIdx
        ].pe += 1;
        state.groups[action.payload.groupIdx].teams[
          action.payload.teamIdx
        ].pts += 1;
      }
    },
    calcGroupRanking: (state, action) => {
      const cloneTeams = state.groups[action.payload].teams.map((x) => x);
      let rank1_index = get_rank1_index(cloneTeams);
      state.groups[action.payload].teams[0] = cloneTeams[rank1_index];
      cloneTeams.splice(rank1_index, 1);
      let rank2_index = get_rank1_index(cloneTeams);
      state.groups[action.payload].teams[1] = cloneTeams[rank2_index];
      cloneTeams.splice(rank2_index, 1);
      let rank3_index = get_rank1_index(cloneTeams);
      state.groups[action.payload].teams[2] = cloneTeams[rank3_index];
      cloneTeams.splice(rank3_index, 1);
      state.groups[action.payload].teams[3] = cloneTeams[0];
    },
    calcBtnClicked: (state, action) => {
      state.groups[action.payload].isCalcBtnClicked = true;
    },
    setWinner: (state, action) => {
      state.knockoutStageMatches[action.payload.matchIdx][
        action.payload.teamIdx
      ].winner = true;
      state.knockoutStageMatches[action.payload.matchIdx][
        (action.payload.teamIdx + 1) % 2
      ].winner = false;
    },
    goTo16: (state) => {
      state.step.groupStage = false;
      state.step.knockOut16 = true;
      for (let i = 0; i < state.knockoutStageMatches.length; i++) {
        if (i < 4) {
          state.knockoutStageMatches[i][0].nation =
            state.groups[i * 2].teams[0].nation;
          state.knockoutStageMatches[i][1].nation =
            state.groups[i * 2 + 1].teams[1].nation;
        } else {
          state.knockoutStageMatches[i][0].nation =
            state.groups[i * 2 - 7].teams[0].nation;
          state.knockoutStageMatches[i][1].nation =
            state.groups[i * 2 - 8].teams[1].nation;
        }
      }
    },
    goTo8: (state) => {
      state.step.knockOut16 = false;
      state.step.knockOut8 = true;
      for (let i = 0; i < 4; i++) {
        for (let j = 0; j < 2; j++) {
          state.knockoutStageMatches[i][j].nation =
            state.knockoutStageMatches[2 * i + j][
              state.knockoutStageMatches[2 * i + j][0].winner ? 0 : 1
            ].nation;
          state.knockoutStageMatches[i][j].winner = false;
        }
      }
    },
    goToSemiFinal: (state) => {
      state.step.knockOut8 = false;
      state.step.semiFinal = true;
      for (let i = 0; i < 2; i++) {
        for (let j = 0; j < 2; j++) {
          state.knockoutStageMatches[i][j].nation =
            state.knockoutStageMatches[2 * i + j][
              state.knockoutStageMatches[2 * i + j][0].winner ? 0 : 1
            ].nation;
          state.knockoutStageMatches[i][j].winner = false;
        }
      }
    },
    goToFinal: (state) => {
      state.step.semiFinal = false;
      state.step.final = true;
      for (let j = 0; j < 2; j++) {
        state.knockoutStageMatches[0][j].nation =
          state.knockoutStageMatches[j][
            state.knockoutStageMatches[j][0].winner ? 0 : 1
          ].nation;
        state.knockoutStageMatches[0][j].winner = false;
      }
    },
    goToResult: (state) => {
      state.step.final = false;
      state.step.result = true;
    },
  },
});

const get_rank1_index = (cloneTeams) => {
  let rank1_index = 0;
  for (let i = 1; i < cloneTeams.length; i++) {
    if (cloneTeams[i].pts > cloneTeams[rank1_index].pts) {
      rank1_index = i;
    } else if (cloneTeams[i].pts === cloneTeams[rank1_index].pts) {
      if (cloneTeams[i].dif > cloneTeams[rank1_index].dif) {
        rank1_index = i;
      } else if (cloneTeams[i].dif === cloneTeams[rank1_index].dif) {
        if (cloneTeams[i].gf > cloneTeams[rank1_index].gf) {
          rank1_index = i;
        }
      }
    }
  }
  return rank1_index;
};

export const {
  changeMatchGoals,
  checkAllFilled,
  calcBtnClicked,
  updateTeamScore,
  calcGroupRanking,
  setWinner,
  goTo16,
  goTo8,
  goToSemiFinal,
  goToFinal,
  goToResult,
} = teamSlice.actions;

export default teamSlice.reducer;
